import { useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';

import { DUMMY_IDENTIFIER, INSURANCE_COMPANIES } from '../../../constants';

const UnregisteredCompania = () => {
  const params = useParams<{ webParam: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const realCompany =
      Object.values(INSURANCE_COMPANIES).find((company) => company.webParam === params.webParam) || null;

    const companyCode = realCompany?.value ?? '00000016';

    const timestamp = Math.floor(Date.now() / 1000);

    const url = `/unregistered/${timestamp}/${companyCode}/${DUMMY_IDENTIFIER}/es`;

    navigate(url, {
      replace: true,
    });
  }, [params, navigate]);

  return <></>;
};

export default UnregisteredCompania;
